import * as types from './constants';

// Get Performance Links
export const getPerformanceLinksRequest = data => (
  { type: types.GET_PERFORMANCE_LINKS_REQUEST, payload: data }
);

export const getPerformanceLinksDone = data => (
  { type: types.GET_PERFORMANCE_LINKS_DONE, payload: data }
);

export const getPerformanceLinksFailed = errors => (
  { type: types.GET_PERFORMANCE_LINKS_FAILED, payload: errors }
);

// Operations
export const updateUserPerformanceLinks = data => (
  { type: types.UPDATE_USER_PERFORMANCE_LINKS, payload: data }
);

export const togglePerformanceLinks = data => (
  { type: types.TOGGLE_PERFORMANCE_LINKS, payload: data }
);

export const toggleAllPerformanceLinks = data => (
  { type: types.TOGGLE_ALL_PERFORMANCE_LINKS, payload: data }
);

export const setPerformanceLinksUsersToFilter = data => (
  { type: types.SET_PERFORMANCE_LINKS_USERS_TO_FILTER, payload: data }
);

export const setFilter = data => (
  { type: types.SET_PERFORMANCE_LINKS_FILTER, payload: data }
);

export const setAllFilters = data => (
  { type: types.SET_PERFORMANCE_LINKS_ALL_FILTERS, payload: data }
);

export const clearFilters = (filterToUpdate, mobile) => (
  { type: types.CLEAR_PERFORMANCE_LINKS_FILTERS, payload: { filterToUpdate, mobile } }
);

export const performanceLinksSetPage = data => (
  { type: types.PERFORMANCE_LINKS_SET_PAGE, payload: data }
);

export const performanceLinksErrorsReset = () => (
  { type: types.PERFORMANCE_LINKS_ERRORS_RESET }
);

export const performanceLinksReset = data => (
  { type: types.PERFORMANCE_LINKS_RESET, payload: data }
);